import {
  AllReceiversParams,
  getAllDistributorsWithStats,
  getAllReceiversWithStats,
} from '@/api/admin.api';
import { queryKeys } from '@/queryKeys';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

export const useGetAllReceiversWithStats = (params: AllReceiversParams) => {
  return useQuery({
    queryKey: queryKeys.admin.allReceivers(params),
    queryFn: () => getAllReceiversWithStats(params),
    placeholderData: keepPreviousData,
  });
};

export const useGetAllDistributorsWithStats = (params: AllReceiversParams) => {
  return useQuery({
    queryKey: queryKeys.admin.allDistributors(params),
    queryFn: () => getAllDistributorsWithStats(params),
    placeholderData: keepPreviousData,
  });
};
